(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const syncCollectionVideoTileHeight = () => {
  document.querySelectorAll('.collection-video-tile').forEach((videoTile) => {
    const nextProductTile = videoTile.nextElementSibling;

    if (!nextProductTile?.classList.contains('product-grid__item')) return;

    const productCard = nextProductTile.querySelector('.product-grid__card');

    if (!productCard) return;

    const setVideoHeight = () => {
      const productCardHeight = productCard.getBoundingClientRect().height;

      if (productCardHeight > 0) {
        videoTile.style.height = `${Math.ceil(productCardHeight)}px`;
      }
    };

    setVideoHeight();

    if (!videoTile.dataset.heightObserverAttached) {
      const resizeObserver = new ResizeObserver(setVideoHeight);
      resizeObserver.observe(productCard);

      videoTile.dataset.heightObserverAttached = 'true';
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(syncCollectionVideoTileHeight);
});

window.addEventListener('load', syncCollectionVideoTileHeight);
window.addEventListener('resize', syncCollectionVideoTileHeight);

document.addEventListener('shopify:section:load', syncCollectionVideoTileHeight);

const resultsList = document.querySelector('results-list');


if (resultsList) {
  const resultsObserver = new MutationObserver(() => {
    requestAnimationFrame(syncCollectionVideoTileHeight);
  });

  resultsObserver.observe(resultsList, {
    childList: true,
    subtree: true
  });
}

  } catch(e) { console.error(e); }
})();
})();
